import {
  Colors,
  type MediumIcon,
  SelectOptionGroups,
  TagColor,
} from '@factorialco/deprecated-design-system'
import {
  AtsApplicationPhaseTypeEnum,
  AtsHiringStageNamesEnum,
  GetHiringStagesQuery,
} from 'generated/resources/graphql'

type AtsHiringStage = NonNullable<
  NonNullable<NonNullable<GetHiringStagesQuery['ats']>['hiringStagesConnection']>['nodes']
>[0]

export type StageProperty = {
  icon: MediumIcon
  color: Colors
  tagColor: TagColor
}

export const UNASSIGNED_STAGE = 'unassigned' as const
export type AtsHiringStageNames = AtsHiringStageNamesEnum | typeof UNASSIGNED_STAGE

export const isNew = (stageName: AtsHiringStageNames) => stageName == 'new'
export const isHired = (stageName: AtsHiringStageNames) => stageName == 'hired'

export const getPhaseType = (
  stageName: AtsHiringStageNamesEnum
): AtsApplicationPhaseTypeEnum | undefined => {
  switch (stageName) {
    case 'new':
      return 'initial'
    case 'screening':
      return 'screening'
    case 'interview':
      return 'interview'
    case 'assessment':
      return 'assessment'
    case 'offer':
      return 'offer'
    case 'hired':
      return 'hired'
  }
}

export const getProperties = (stageName: AtsHiringStageNames): StageProperty => {
  switch (stageName) {
    case 'new':
      return { icon: 'inbox', color: 'lime1000', tagColor: TagColor.lime }
    case 'screening':
      return { icon: 'phone', color: 'viridian1000', tagColor: TagColor.viridian }
    case 'interview':
      return {
        icon: 'comment',
        color: 'champagne1000',
        tagColor: TagColor.champagne,
      }
    case 'assessment':
      return { icon: 'pencil', color: 'radicalRed600', tagColor: TagColor.radical }
    case 'offer':
      return { icon: 'sign', color: 'purple1000', tagColor: TagColor.purple }
    case 'hired':
      return {
        icon: 'check-circle',
        color: 'malibu1000',
        tagColor: TagColor.malibu,
      }
    case 'unassigned':
      return {
        icon: 'alert-circle',
        color: 'radicalRed1500',
        tagColor: TagColor.radical,
      }
    default:
      return {
        icon: 'alert-circle',
        color: 'radicalRed1500',
        tagColor: TagColor.radical,
      }
  }
}

export const isHiringStageEditable = (stageName: AtsHiringStageNames) => {
  return stageName != 'new' && stageName != 'hired'
}

type PartialHiringStage = Pick<AtsHiringStage, 'id' | 'name' | 'label'>

export const getEditableStages = <T extends PartialHiringStage>(stages: T[]) => {
  return stages.filter((stage) => isHiringStageEditable(stage.name))
}

export const editableStagesOptions = (stages: PartialHiringStage[]): SelectOptionGroups => {
  return getEditableStages(stages).map((stage) => {
    return { label: stage.label, value: stage.id }
  })
}
